export default __webpack_public_path__ + "static/meet-977fece25210c08254c466d5a0785c16.png";